var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.152 1.283.355.354L8.142 8l6.365 6.364-.355.354-.353.354-6.365-6.364-6.363 6.364-.353-.354-.354-.354L6.727 8 .364 1.637 1.071.93l6.363 6.363L13.8.93z"
  })));
};
export default SvgX;